import React, { useState, useEffect, CSSProperties } from "react";

interface IProps {
  minImg: string;
  maxImg: string;
}

interface IStyle {
  imgContainer?: CSSProperties;
  mouseBlock?: CSSProperties;
  maskBlock?: CSSProperties;
  magnifierContainer?: CSSProperties;
  imgStyle?: CSSProperties;
  imgStyle2?: CSSProperties;
  imgContainerPicture?: CSSProperties;
}

// 图片放大镜
const ImageMagnifier = (props: IProps) => {
  const [paramss, setParams] = useState({
    // 放大倍数
    scale: 2,
    // 组件宽
    width: 470,
    // 组件高
    height: 535,
    // 鼠标悬停小方块宽度
    mouseBlockWidth: 300,
    // 鼠标悬停小方块高度
    mouseBlockHeight: 300,
  });
  const [minImg, setMinImg] = useState<string>("");
  const [maxImg, setMaxImg] = useState<string>("");
  const [magnifierOff, setMagnifierOff] = useState<boolean>(false);
  const [imgLoad, setImgLoad] = useState<boolean>(false);
  const [cssStyles, setCssStyle] = useState<IStyle>({
    // 图片容器样式
    imgContainer: {
      width: paramss.width + "px",
      height: paramss.height + "px",
      cursor: "move",
      position: "relative",
      background: "#f6f6f6",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    imgContainerPicture: {
      width: paramss.width + "px",
      height: paramss.height + "px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    // 鼠标悬停小方块样式
    mouseBlock: {
      position: "absolute",
      top: "0",
      left: "0",
      width: paramss.mouseBlockWidth + "px",
      height: paramss.mouseBlockHeight + "px",
      background: "rgba(0,0,0,0.1)",
      zIndex: 29,
    },
    // 鼠标悬停遮罩层样式
    maskBlock: {
      position: "absolute",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0)",
      zIndex: 30,
    },
    //  放大镜容器样式
    magnifierContainer: {
      position: "absolute",
      left: paramss.width + "px",
      top: "0",
      width: paramss.width + "px",
      height: paramss.height + "px",
      overflow: "hidden",
      zIndex: 28,
      background: "#f6f6f6",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    // 图片样式
    imgStyle: {
      // width: paramss.width + "px",
      // height: paramss.height + "px",
      maxWidth: "100%",
      maxHeight: "100%",
    },
    // 图片放大样式
    // 此处图片宽高不能设置为百分比，在scale的作用下，放大的只是图片初始的宽高 ！！！
    imgStyle2: {
      // width: paramss.mouseBlockWidth * paramss.scale + "px",
      // height: paramss.mouseBlockHeight * paramss.scale + "px",
      maxWidth: paramss.width + "px",
      maxHeight: paramss.height + "px",
      // position: "absolute",
      top: 0,
      right: 0,
      transform: "scale(2)",
      transformOrigin: "top left",
    },
  });

  /**
   * 生命周期函数
   */
  // 组件初始化
  useEffect(() => {
    initParam();
    updataImg(props);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  /**
   * 方法
   */
  // 鼠标移入
  const mouseEnter = () => {
    // setMagnifierOff(true);
  };
  // 鼠标移除
  const mouseLeave = () => {
    setMagnifierOff(false);
    let cssStyle = JSON.parse(JSON.stringify(cssStyles));
    cssStyle.imgStyle2.width = null;
    cssStyle.imgStyle2.height = null;
    setCssStyle(cssStyle);
  };
  // 鼠标移动
  const mouseMove = (event: any) => {
    // console.log(event);
    setMagnifierOff(true);
    let e = event.nativeEvent;
    calculationBlock(e.offsetX, e.offsetY);
  };

  // 计算相关参数
  const calculationBlock = (offsetX: number, offsetY: number) => {
    let cssStyle = JSON.parse(JSON.stringify(cssStyles));

    /* 小方块位置 */
    // 防止鼠标移动过快导致计算失误，只要小于或者大于对应值，直接设置偏移量等于最小值或者最大值
    if (offsetX < 150) {
      offsetX = 150;
    }
    if (offsetX > 320) {
      offsetX = 320;
    }
    if (offsetY < 150) {
      offsetY = 150;
    }
    if (offsetY > 385) {
      offsetY = 385;
    }
    cssStyle.mouseBlock.left = parseFloat((offsetX - 150).toString()) + "px";
    cssStyle.mouseBlock.top = parseFloat((offsetY - 150).toString()) + "px";

    const img = document.getElementById("img");
    cssStyle.imgStyle2.width = img?.clientWidth + "px";
    cssStyle.imgStyle2.height = img?.clientHeight + "px";

    /* 计算图片放大位置 */
    // cssStyle.imgStyle2.left =
    //   parseFloat((-(offsetX - 150) * 2).toString()) + "px";
    // cssStyle.imgStyle2.top =
    //   parseFloat((-(offsetY - 150) * 2).toString()) + "px";
    const imgLeft = parseFloat((-(offsetX - 150) * 1.3).toString()) + "px";
    const imgTop = parseFloat((-(offsetY - 150) * 1.3).toString()) + "px";
    cssStyle.imgStyle2.transform = `scale(${paramss.scale}) translateX(${imgLeft}) translateY(${imgTop})`;
    setCssStyle(cssStyle);
  };

  // 初始化静态参数
  const initParam = () => {
    let cssStyle = JSON.parse(JSON.stringify(cssStyles));
    let params = JSON.parse(JSON.stringify(paramss));

    cssStyle.imgContainer.width = params.width + "px";
    cssStyle.imgContainer.height = params.height + "px";
    cssStyle.magnifierContainer.width = params.width + "px";
    cssStyle.magnifierContainer.height = params.height + "px";
    // cssStyle.magnifierContainer.left = params.width + "px";
    // cssStyle.imgStyle2.width = params.width + "px";
    // cssStyle.imgStyle2.height = params.height + "px";
    cssStyle.imgStyle2.transform = `scale(${params.scale})`;
    setCssStyle(cssStyle);
  };

  // 更新图片
  const updataImg = (props: IProps) => {
    setMinImg(props.minImg);
    setMaxImg(props.maxImg);
  };
  // 图片加载情况
  const handleImageLoaded = () => {
    // console.log(e);
    setImgLoad(true);
  };

  // 图片加载中
  const handleImageErrored = () => {
    setImgLoad(false);
  };

  return (
    <div className="relative">
      <div style={cssStyles.imgContainer}>
        <picture style={cssStyles.imgContainerPicture}>
          <img id="img" style={cssStyles.imgStyle} src={minImg} alt="" />
          <div
            style={cssStyles.maskBlock}
            onMouseEnter={mouseEnter}
            onMouseLeave={mouseLeave}
            onMouseMove={mouseMove}
          />
        </picture>
        {magnifierOff && <div style={cssStyles.mouseBlock} />}
      </div>
      {magnifierOff && (
        <div style={cssStyles.magnifierContainer}>
          <picture>
            <img
              style={cssStyles.imgStyle2}
              src={maxImg}
              onLoad={handleImageLoaded}
              onError={handleImageErrored}
              alt=""
            />
          </picture>
          {!imgLoad && "failed to load"}
        </div>
      )}
    </div>
  );
};

export default ImageMagnifier;
